module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMTkuNSIgZmlsbD0iIzk4MjQxQyIgc3Ryb2tlPSIjRTNFQ0VGIi8+CjxwYXRoIGQ9Ik0yMiAyN1YxM0gyNlYyN0gyMlpNMTQgMjdWMTNIMThWMjdIMTRaIiBmaWxsPSIjRTNFQ0VGIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./images/pause-icon.svg
// module id = 378
// module chunks = 0